import type { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const initialState: AuthState = {
  user: null,
};

const setUser: CaseReducer<AuthState, PayloadAction<AuthState['user']>> = (state, action) => {
  state.user = action.payload;
};

const clearUser: CaseReducer<AuthState> = (state) => {
  state.user = null;
};

const authSlice = createSlice({
  name: 'authSlice',
  initialState,
  reducers: {
    setUser,
    clearUser,
  },
});

export const authActions = authSlice.actions;

export default authSlice.reducer;
